import React from "react";

const FeatureCard = ({ icon, title, description }) => {
  return (
    <article className="p-8 bg-white rounded-2xl shadow-[0_4px_6px_rgba(0,0,0,0.05)]">
      <div className="mb-4 text-3xl" aria-hidden="true">
        {icon}
      </div>
      <h3 className="mb-3 text-xl font-semibold">{title}</h3>
      <p className="leading-relaxed text-stone-500">{description}</p>
    </article>
  );
};

export default FeatureCard;
